import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ShopperOverviewMovementPage } from "./../shopper-overview-movement/shopper-overview-movement";
import { ShopperOverviewPlazaPage } from "./../shopper-overview-plaza/shopper-overview-plaza";
import { ShopperOverviewCashPage } from "./../shopper-overview-cash/shopper-overview-cash";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-shopper-overview",
  templateUrl: "shopper-overview.html",
})
export class ShopperOverviewPage {
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log('ionViewDidLoad PlazaOverviewPage');
  }

  backPage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  cash() {
    this.navCtrl.push(ShopperOverviewCashPage);
  }

  plazamap() {
    this.navCtrl.push(ShopperOverviewPlazaPage);
  }

  movement() {
    this.navCtrl.push(ShopperOverviewMovementPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-overview/shopper-overview.ts